import React, { FC, useCallback, useContext } from 'react';
import usePastTime from 'hooks/usePastTime';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';
import ListingBanner from 'router/subrouters/Dash/subrouters/private/subrouters/Portfolio/subrouters/Seller/subrouters/ListingDetailSeller/subrouters/ListingInformation/components/ManageListingVisibility/components/ListingBanner';
import DraftListingContext from 'providers/DraftListing/DraftListing.context';
import XIcon from 'icons/X.icon';
import api from 'api';
import ClockIcon from 'icons/Clock.icon';
import { SELLING_PORTFOLIO_ROUTE } from 'data/global';
import { LISTING_STATUS_FILTER_KEY } from 'router/subrouters/Dash/subrouters/private/subrouters/Portfolio/components/PortfolioSellerFilters/data';
import { LISTING_STAGE } from 'models/Listing';
import useQueryFilter from 'hooks/useQueryFilter';

import './DraftListingBanner.styles.scss';

type DraftListingBannerProps = {
  className?: string;
};

const DraftListingBanner: FC<DraftListingBannerProps> = ({ className }) => {
  const { hasDraftBanner, draftListing, removeDraftListing } =
    useContext(DraftListingContext);

  const { _id: listingId, createdAt, listingTitle } = draftListing || {};

  const { t } = useTranslation();
  const { onFiltersApplyAndNavigate } = useQueryFilter();

  const createdDate = usePastTime()(createdAt);

  const classes = classNames('draft-listing-banner', className);

  const onCompleteListing = useCallback(() => {
    onFiltersApplyAndNavigate(
      SELLING_PORTFOLIO_ROUTE,
      LISTING_STATUS_FILTER_KEY,
      LISTING_STAGE.DRAFT,
    );
  }, [onFiltersApplyAndNavigate]);

  const onSnoozeBanner = useCallback(() => {
    api.portfolio.seller.snoozeDraft(listingId);
    removeDraftListing();
  }, [listingId, removeDraftListing]);

  const onCloseBanner = useCallback(() => {
    api.portfolio.seller.clearDraft(listingId);
    removeDraftListing();
  }, [listingId, removeDraftListing]);

  if (!hasDraftBanner) return null;

  return (
    <ListingBanner
      className={classes}
      title={t('youGotDraftListingAwaiting')}
      description={t('draftStartedTitle', {
        listingTitle,
        date: createdDate,
      })}
    >
      <Button variant="outline" onClick={onCompleteListing}>
        {t('completeListing')}
      </Button>
      <Button variant="link" icon={ClockIcon} onClick={onSnoozeBanner}>
        {t('snooze')}
      </Button>
      <Button variant="link" icon={XIcon} onClick={onCloseBanner}>
        {t('deleteDraft')}
      </Button>
    </ListingBanner>
  );
};

export default DraftListingBanner;
